<template>
  <confirm-modal ref="modal">
    <template slot="body">
      <p>Deseja realmente cancelar sua assinatura? Você ainda poderá utilizar seus créditos conforme a política de validade dos mesmos.</p>
    </template>
  </confirm-modal>
</template>

<script>
import ConfirmModal from '@/support/components/modal/ConfirmModal.vue';

export default {
  name: 'ConfirmCancelSubscription',

  methods: {
    /**
     * Confirm the change endpoint name.
     *
     * @returns {Promise<boolean>}
     */
    confirm() {
      return this.$refs.modal.confirm();
    },
  },

  components: {
    ConfirmModal,
  },
};
</script>

<style lang="scss" scoped>

</style>
